(function () {
    /***************** Setup **************/

    const popup = document.querySelector("#welcomePopup");

    // the snippet renders from the layout, but guard so a template that drops it cannot throw
    if (!popup) {
        return;
    }

    const submitButton = popup.querySelector("#welcomePopupContentIntroSignupSubmit");
    const customerEmail = popup.querySelector("#welcomePopupContentIntroSignupEmail");

    const formError = popup.querySelector("#welcomePopupContentIntroSignupError");

    // lives outside the dialog, so it is queried from the document rather than the popup
    const signupTrigger = document.querySelector("#signupTrigger");

    const successTitle = popup.querySelector('#welcomePopupContentSuccessTitle');
    const successLinks = popup.querySelector("#welcomePopupContentSuccessLinks");

    // sessionStorage key so the popup only opens itself once, not on every page they browse
    const WELCOME_SIGNUP_KEY = "WELCOME_SIGNUP";

    // separate from the key above, which a plain dismissal also sets. this one means they have had
    // a real answer, so the trigger has nothing left to offer them. dismissing should still leave a
    // way back in, which is the whole point of the trigger
    const WELCOME_ANSWERED_KEY = "WELCOME_ANSWERED";

    // build the buttons with the title and url
    // shared between the eligible and ineligible for discount paths
    let URLs = {
        "Shop PlantPaper": `/pages/plant-paper`,
        "Shop PlantPaper Towel": `/pages/paper-towel`,
        "Shop Tissue": `/pages/tissues`
    }

    // true for the length of the close transition, so a trigger click cannot reopen mid close
    let isInteracting = false;

    // holds the close transition timer so repeat closes cannot stack them
    let popupTimer = null;

    /***************** Open / Close **************/

    function openSignupPopup() {
        // already open, or still finishing its close transition
        if (popup.open || isInteracting) {
            return;
        }

        // a visitor already holding a code has nothing to claim here, whether it arrived on an ad
        // link or on the way out of this very popup. same gate theme-welcome-discount.js uses to
        // suppress the klaviyo popup
        if (Cookies.get("discount_code")) {
            return;
        }

        popup.showModal();
        popup.classList.add("active");
        document.querySelector("body").classList.add("noScroll");

        // slide the trigger away so it does not sit dimmed behind the backdrop
        signupTrigger?.classList.add("hidden");
    }

    function closeSignupPopup() {
        // already closing, so let the running transition finish rather than starting a second one
        if (isInteracting || !popup.open) {
            return;
        }

        // dismissing is an answer too. without this it returns on every page they browse, and the
        // snippet renders from the layout so that is every page on the site
        retireSignupPopup();

        // held for the length of the transition, which is what stops a reopen before it lands
        isInteracting = true;

        clearTimeout(popupTimer);
        popup.classList.remove("active");

        // wait for the transition to finish before actually closing
        popupTimer = setTimeout(function () {
            popup.close();
            document.querySelector("body").classList.remove("noScroll");
            isInteracting = false;

            // brought back only once the backdrop is gone, otherwise it slides in behind it
            signupTrigger?.classList.remove("hidden");
        }, 500);
    }

    /***************** Email Validation Check **************/

    customerEmail?.addEventListener("input", function (e) {
        // simple email regex check and disable attribute toggle
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        submitButton.toggleAttribute("disabled", !emailRegex.test(e.target.value));

        // whatever they were told last time no longer describes what is in the field
        hideFormError();
    });

    /***************** Retire / Focus **************/

    // stop the popup opening itself again for the rest of the session
    function retireSignupPopup() {
        sessionStorage.setItem(WELCOME_SIGNUP_KEY, "1");
    }

    // claim the code without a navigation, so someone who closes the popup rather than clicking a
    // link still leaves holding it
    async function applyDiscountCode(code) {
        try {
            await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`);
        } catch (error) {
            console.error(`Could not apply discount ${code}.`);
        }
    }

    // openSignupPopup refuses to open for someone who has had their answer or already holds a code,
    // so leaving the trigger on screen gives them a button that silently does nothing
    function refreshTriggerVisibility() {
        const spent = sessionStorage.getItem(WELCOME_ANSWERED_KEY) || Cookies.get("discount_code");
        signupTrigger?.classList.toggle("retired", !!spent);
    }

    // the pane that had focus is display:none once the swap runs, which drops focus to body and
    // takes the dialog's focus trap with it. hand it to the new pane's heading instead
    // also update the dialog aria labels to reflect the content change
    function focusSuccessPane() {
        successTitle.setAttribute("tabindex", "-1");
        successTitle.focus();
        popup.setAttribute("aria-labelledby", "welcomePopupContentSuccessTitle");
        popup.removeAttribute("aria-describedby");
    }

    /***************** Form Error **************/

    // a correctable failure keeps them on the intro pane, so it reports inline under the form
    // rather than switching to the success pane, which has no way back
    function showFormError(message) {
        formError.textContent = message;
        formError.classList.add("active");
    }

    function hideFormError() {
        formError.classList.remove("active");
    }

    /***************** Submit **************/

    popup.querySelector("#welcomePopupContentIntroSignup")?.addEventListener("submit", async function (e) {
        // prevent default action
        e.preventDefault();

        // if we don't have an email for whatever reason, exit
        if (!customerEmail.value) {
            return;
        }

        // clear anything a previous attempt left behind
        hideFormError();

        // add loading to button
        submitButton.classList.add("loading");

        let response;

        try {
            // hold the loading state for a minimum beat alongside the request, so a fast answer
            // still reads as work rather than a flicker without adding that beat onto a slow one
            const [signup] = await Promise.all([
                // determine customer's discount eligibility
                fetch(`${root}/discount/welcome-signup.php`, {
                    method: "POST",
                    body: JSON.stringify({
                        email: customerEmail.value,
                    })
                }).then(response => response.json()),
                sleep(2000)
            ]);

            response = signup;
        } catch (e) {
            console.error(e);
            showFormError("Something went wrong. Please try again.");
            return;
        } finally {
            // remove loading from button
            submitButton.classList.remove("loading");
        }

        // a failed request is not an eligibility answer, so it stays on the form where they can
        // correct the address or retry. the raw message is for us, never for them
        if (response.error) {
            console.error(response.error);
            showFormError("Something went wrong. Please try again.");
            return;
        }

        // past this point we have a real answer, so the pane can switch
        popup.querySelector('#welcomePopupContentIntro').classList.remove("active");
        popup.querySelector('#welcomePopupContentSuccess').classList.add("active");

        // they have already had the welcome offer, so say so and give them a way out
        if (response.eligible === false) {
            successTitle.innerHTML = `It looks like you’ve previously used this discount on a prior PlantPaper subscription. You can reactivate your <a class="welcomePopupContentSuccessTitleLink" href="/account">subscription</a>, or click below to shop.`;
        }
        // if we received a response containing a discount code, test it against our server to make sure it's valid
        else {
            // claim it now rather than on a link click, so dismissing the popup does not throw the code away
            sessionStorage.setItem(WELCOME_SOURCE_KEY, response.code);
            applyDiscountCode(response.code);

            let fetchedCode = null;

            try {
                fetchedCode = await fetch(`${root}/discount/get-code.php?code=${encodeURIComponent(response.code)}`).then(res => res.json());
            } catch (error) {
                console.error(`Could not look up discount ${response.code}.`);
            }

            // the api refuses any code it cannot hand us a percentage and a scope for. the code
            // still discounts at checkout either way, so a failed lookup only costs us the figure
            // in the copy. quoting nothing beats bailing out and leaving this pane empty
            let titleHTML = "Your discount has been auto-applied.";

            if (fetchedCode && !fetchedCode.error) {
                successTitle.classList.add("successful");
                titleHTML = `Your ${fetchedCode.percent}% off discount has been auto-applied.`;
            }

            // update the urls with the discount redirect
            Object.entries(URLs).forEach(([label, url]) => {
                URLs[label] = `/discount/${response.code}?redirect=${url}`;
            });

            // update the success language text and pass in the URLs
            successTitle.innerHTML = titleHTML;

            // show the disclaimer
            popup.querySelector('#welcomePopupContentSuccessDisclaimer').classList.add("active");
        }

        // declare html
        let HTML = "";

        // build the HTML and insert
        Object.entries(URLs).forEach(([label, url]) => {
            HTML += `<a class="welcomePopupContentSuccessLinksLink button popupButton" href="${url}">${label}</a>`;
        })
        successLinks.innerHTML = HTML;

        // make sure we prevent the signup from showing again once we get a definitive answer
        retireSignupPopup();
        sessionStorage.setItem(WELCOME_ANSWERED_KEY, "1");

        // retire the trigger too, so closing this does not hand back a button that opens nothing
        refreshTriggerVisibility();

        // the intro pane is hidden by now, so move focus onto what replaced it
        focusSuccessPane();
    });

    /***************** Events **************/

    // bound once, so reopening never stacks a second set of listeners on the same elements

    // x icon click button close
    popup.querySelector("#welcomePopupClose").addEventListener("click", closeSignupPopup);

    // outside click close
    popup.addEventListener("click", function (e) {
        if (e.target === this) {
            closeSignupPopup();
        }
    });

    // esc closes natively and instantly, so mirror the state the transition path would have left
    // rather than calling the closer back into a dialog that is already shut
    popup.addEventListener("close", function () {
        clearTimeout(popupTimer);
        popup.classList.remove("active");
        document.querySelector("body").classList.remove("noScroll");
        isInteracting = false;
        signupTrigger?.classList.remove("hidden");
    });

    // the trigger button to show the signup form. the guard lives inside the handler because a
    // check at bind time only ever sees the flag's initial value
    document.querySelector("#signupTrigger")?.addEventListener("click", openSignupPopup);

    /***************** Init **************/

    // decide the trigger before anything else, so a spent session never paints a dead button
    refreshTriggerVisibility();

    // open on a fresh session, otherwise it only opens by trigger click
    if (!sessionStorage.getItem(WELCOME_SIGNUP_KEY)) {
        setTimeout(() => {
            openSignupPopup();
        }, 2000)
    }
}());
